import { TypeNames } from './options';

export const tabs = [
    {
        key: 'drop-cart',
        label: TypeNames.no_cart,
    },
    {
        key: 'drop-session',
        label: TypeNames.no_order,
    },
];
